<nb-select
	[selected]="selectedCandidateIds"
	multiple
	(selectedChange)="onMembersSelected($event)"
	fullWidth
	placeholder="{{ 'FORM.PLACEHOLDERS.ADD_REMOVE_CANDIDATES' | translate }}"
>
	<nb-option *ngFor="let candidate of allCandidates" [value]="candidate.id">
		<ngx-avatar
			size="sm"
			[src]="candidate.user?.imageUrl"
			[name]="candidate.user?.name"
		></ngx-avatar>
	</nb-option>
</nb-select>
